import { FixedColumn } from "../FixedColumn";

export const getFixedColumnProps = (
  columnId: string,
  fixedColumnIds: FixedColumn[] | undefined,
  fixedColumnWidths: number[],
) => {
  let foundFixedColumn: FixedColumn | undefined;
  let fixedColumnIndex = -1;

  fixedColumnIds?.forEach((columnIdObj, index) => {
    if (columnId === columnIdObj.value) {
      foundFixedColumn = columnIdObj;
      fixedColumnIndex = index;
    }
  });

  const rightOffset =
    fixedColumnIndex !== -1 &&
    fixedColumnWidths &&
    fixedColumnWidths
      .slice(fixedColumnIndex + 1)
      .reduce((acc, width) => acc + width, 0);

  return {
    fixedColumn: foundFixedColumn,
    rightOffset: rightOffset || 0,
  };
};
